import React from 'react';
import styles from './Button.module.scss';
import clsx from 'clsx';
const Button = ({ rightIcon, type = 'primary', children, className, ...props }) => {
  return (
    <button className={clsx(styles.button, className, type == 'danger' && styles.buttonDanger, type == 'success' && styles.buttonSuccess)} {...props}>
      {children}
      {rightIcon}
    </button>
  );
};

export default Button;
